export const SETLLEMENT_PRIMARY_ACTIONS_ARRAY = ['CANCEL', 'REJECT', 'VALIDATE'] as const;
export const SETLLEMENT_SECONDARY_ACTIONS_ARRAY = ['DELIVERY_AND_SECURITIES_CREATION_AND_PAYMENT_TO_BE_VALIDATED', 'DELIVERY_TO_BE_VALIDATED', 'SECURITIES_CREATION_TO_BE_VALIDATED', 'PAYMENT_TO_BE_VALIDATED'] as const;

export const SETLLEMENT_ACTIONS_ARRAY = [...SETLLEMENT_PRIMARY_ACTIONS_ARRAY, ...SETLLEMENT_SECONDARY_ACTIONS_ARRAY];
export type SETTLEMENT_PRIMARY_ACTIONS = typeof SETLLEMENT_PRIMARY_ACTIONS_ARRAY[number];
export type SETTLEMENT_SECONDARY_ACTIONS = typeof SETLLEMENT_SECONDARY_ACTIONS_ARRAY[number];
export type SETTLEMENT_ACTIONS = typeof SETLLEMENT_ACTIONS_ARRAY[number];
